import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Quasar } from 'quasar'
import quasarUserOptions from './quasar-user-options'
import App from './App.vue'
import router from './router'

import './assets/css/main.css'

const pinia = createPinia()

createApp(App)
  .use(pinia)
  .use(router)
  .use(Quasar, quasarUserOptions)
  .mount('#app')

